import {Injectable} from '@angular/core';
import {HttpService} from '../http.service';
import { environment } from 'src/environments/environment';
import {Menu} from '../../../shared-gen/Model/Menus/Menu';
import {PriceList} from '../../../shared-gen/Model/PriceLists/PriceList';
import {LanguagePack} from '../../../shared-gen/Model/Localization/LanguagePack';
import { ExportTimeSpan } from "../../../shared-gen/Devices/WebApi/Api/ExportTimeSpan";

/**
 * Web API for export functions, like transactions export to Excel.
 */
@Injectable({
	providedIn: 'root'
})
export class ExportApi extends HttpService {

	/**
	 * Exports the transactions within the given time span to the first
	 * licensed USB stick.
	 */
	async exportExcelTransactions(timeSpan: ExportTimeSpan): Promise<void> {
		return await this.post(`export/excel/transactions?timeSpan=${timeSpan}`);
	}

}
